// src/components/invoice_terms/InvoiceDashboardMyTermList.js
import React from "react";
import InvoiceTermRow from "./InvoiceTermRow";
import { Card } from "react-bootstrap";
import { useInvoiceData } from "../../../contexts/InvoiceDataContext";
import {euroFormat} from "../../../utils/usefullFunctions";

const InvoiceDashboardMyTermList = ({ user, showUser }) => {
    const { invoiceData, loading } = useInvoiceData();

    // Calculate the count of filtered invoices
    const filteredInvoiceCount = invoiceData.filter(term =>
        term.original.project && term.original.project.projects_employees_employee_name === user.name
    ).length;

    // Calculate the total budget for this user
    const totalBudgetForUser = invoiceData
        .filter(term =>
            term.original.project && term.original.project.projects_employees_employee_name === user.name
        )
        .reduce((total, term) => total + (parseInt(term.original.invoice.projects_invoice_terms_invoice_amount) || 0), 0);

    if (loading) return <div>Loading...</div>;

    return (
        <Card>
            <Card.Header>
                <Card.Title tag="h5" className="mb-0">
                    <h3>Mijn openstaande facturen overzicht ({filteredInvoiceCount}) ({euroFormat(totalBudgetForUser)})</h3>
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <div id="factuur_termijnen">
                    {invoiceData.length > 0 ? (
                        invoiceData
                            .filter(term =>
                                term.original?.project?.projects_employees_employee_name === user.name
                            )
                            .map(term => (
                                <InvoiceTermRow
                                    key={term.original.invoice.projects_invoice_terms_id}
                                    project={term.original.project}
                                    term={term.original.invoice}
                                    dashboard={true}
                                    user={user}
                                />
                            ))
                    ) : (
                        <div className="justify-content-center align-self-center w-100 text-center">
                            Er zijn geen factuur termijnen gevonden.
                        </div>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
};

export default InvoiceDashboardMyTermList;
